import React, { useState } from "react";
import six_slider_1 from '../../assets/six_slider_1.png';
import six_slider_2 from '../../assets/six_slider_2.png';
import six_slider_3 from '../../assets/six_slider_3.avif';
import six_slider_4 from '../../assets/six_slider_4.png';
import six_slider_5 from '../../assets/six_slider_5.png';

const accordion_items = [
  {
    title: '1. Анализ и стратегия',
    content: 'Проводим глубокий анализ рынка, конкурентов и целевой аудитории. Разрабатываем стратегию продвижения, которая принесет реальные результаты.',
    image: six_slider_1,
    bg: 'bg-danger-bg',
  },
  {
    title: '2. Креативная разработка',
    content: 'Создаем уникальные креативы, визуалы, тексты и сценарии. Находим то, что зацепит вашу аудиторию и выделит бренд.',
    image: six_slider_2,
    bg: 'bg-[#E0F7FF]',
  },
  {
    title: '3. Запуск и масштабирование',
    content: 'Запускаем рекламные кампании на всех платформах. Оптимизируем и масштабируем то, что работает лучше всего.',
    image: six_slider_3,
    bg: 'bg-[#F0EFFF]',
  },
  {
    title: '4. Мониторинг и оптимизация',
    content: 'Ежедневно отслеживаем показатели, тестируем гипотезы и улучшаем результаты. Ваши деньги работают максимально эффективно.',
    image: six_slider_4,
    bg: 'bg-warning-bg',
  },
  {
    title: '5. Отчетность и ROI',
    content: 'Предоставляем прозрачную отчетность по каждому проекту. Доказываем окупаемость каждого вложенного рубля.',
    image: six_slider_5,
    bg: 'bg-[#E8FFF0]',
  },
];

const Icon = ({ name, size = 16 }) => {
  const common = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "shrink-0",
  };

  const paths = {
    arrow: <><path d="M5 12h13" /><path d="m13 6 6 6-6 6" /></>,
  };

  return <svg {...common}>{paths[name]}</svg>;
};

const SplitAccordionBlock = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="bg-bg py-14 font-[Inter,Manrope,Arial,sans-serif] text-content">
      <div className="mx-auto max-w-[1240px] px-4">
        
        {/* Шапка блока */}
        <div className="mb-8 flex flex-wrap items-end justify-between gap-4 border-b border-line pb-4">
          <div>
            <div className="mb-1 text-[10px] font-normal uppercase tracking-[.2em] text-accent">
              Процесс
            </div>
            <h2 className="text-2xl font-light tracking-tight text-content sm:text-3xl">
              Как мы работаем
            </h2>
          </div>
        </div>

        {/* Основной контейнер-карточка */}
        <div className="overflow-hidden rounded-2xl border border-line-strong bg-surface shadow-[0_10px_30px_rgba(0,0,0,0.03)] flex flex-col md:flex-row items-stretch">
          
          {/* Левая часть: Аккордеон */}
          <div className="w-full md:w-1/2 flex flex-col gap-3 p-6 sm:p-8 bg-surface justify-center">
            {accordion_items.map((item, index) => {
              const isActive = activeIndex === index;

              return (
                <div
                  key={index}
                  onClick={() => setActiveIndex(index)}
                  className={`cursor-pointer p-5 rounded-xl border transition-all duration-300 ${
                    isActive
                      ? 'border-accent bg-accent-soft shadow-sm'
                      : 'border-line-strong bg-surface hover:border-line-strong'
                  }`}
                >
                  <div className="flex justify-between items-center">
                    <h3 className={`text-xs font-medium transition-colors ${
                      isActive ? 'text-accent' : 'text-content'
                    }`}>
                      {item.title}
                    </h3>

                    {/* Плюс / Минус иконка */}
                    <div className="relative w-4 h-4 flex items-center justify-center text-muted">
                      <span className={`absolute w-3 h-[1.5px] bg-current transition-transform duration-300 ${isActive ? 'rotate-180' : ''}`} />
                      <span className={`absolute h-3 w-[1.5px] bg-current transition-transform duration-300 ${isActive ? 'rotate-90 opacity-0' : ''}`} />
                    </div>
                  </div>

                  {isActive && (
                    <p className="text-[11px] font-light mt-3 text-muted leading-relaxed animate-fadeIn">
                      {item.content}
                    </p>
                  )}
                </div>
              );
            })}
          </div>

          {/* Правая часть: Картинка с динамическим пастельным фоном */}
          <div className={`w-full md:w-1/2 flex items-center justify-center p-8 transition-colors duration-700 ${accordion_items[activeIndex].bg}`}>
            <img
              src={accordion_items[activeIndex].image}
              alt="Процесс работы"
              className="max-h-[360px] w-auto object-contain transition-all duration-500 hover:scale-105"
            />
          </div>

        </div>

        {/* Кнопка внизу */}
        <div className="mt-8 text-center">
          <button className="shine inline-flex items-center gap-2 rounded-lg bg-accent px-6 py-3 text-xs font-medium text-white transition hover:bg-accent-hover">
            Начать сотрудничество <Icon name="arrow" size={13} />
          </button>
        </div>

      </div>
    </section>
  );
};

export default SplitAccordionBlock;